export class ValidationCheckService {
    constructor(validationCheckRepository) {
      this.validationCheckRepository = validationCheckRepository;
    }
    
    async validarCliente(data) {
      try {
        const { documentNumber } = data;
        const validationCheckList = await this.validationCheckRepository.validationCheck(documentNumber);
        return validationCheckList;
      } catch (error) {
        console.log("erro" + error)
        throw new Error(error)
      }
    }
    
    converterDataParaDate(dataString) {
      try {
        const [dia, mes, ano] = dataString.split('/').map(Number);
        return new Date(ano, mes - 1, dia);
      } catch (e) {
        return null;
      }
    }
  }